import { useState } from "react";
import { MessageSquare, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { useLang } from "../../i18n/LangContext";
import { useChannels, Filigree } from "./Brand";
import { useFooterVisible, useScrolledPast, useIsMobile } from "./FooterParts";

export const IdModal = ({ open, onOpenChange }) => {
  const { modal: t } = useLang().t;
  const CHANNELS = useChannels();
  return (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="id-modal" className="border-[#D4AF37]/40 bg-[#0E0F14]/95 text-white backdrop-blur-xl sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="font-serif text-2xl uppercase text-white">{t.a} <span className="gold-text">{t.gold}</span></DialogTitle>
        <DialogDescription className="text-zinc-400">{t.desc}</DialogDescription>
      </DialogHeader>
      <Filigree />
      <div className="mt-2 flex flex-col gap-3">
        {CHANNELS.map((c) => (
          <a key={c.key} href={c.href} target="_blank" rel="noreferrer" data-testid={`modal-channel-${c.key}`}
            className="flex items-center justify-between rounded-xl border border-[#D4AF37]/25 bg-white/[0.03] px-5 py-4 transition-colors hover:border-[#D4AF37]">
            <span className="flex items-center gap-3"><c.icon style={{ color: c.color }} size={20} />{c.label}</span>
            <span className="text-xs uppercase tracking-widest text-[#D4AF37]">{t.connect}</span>
          </a>
        ))}
      </div>
    </DialogContent>
  </Dialog>
  );
};

export const FloatingContact = () => {
  const [open, setOpen] = useState(false);
  const { demo } = useLang().t;
  const CHANNELS = useChannels();
  const footerVisible = useFooterVisible();
  const scrolled = useScrolledPast(400);
  const mobile = useIsMobile();
  const compact = (footerVisible || (!scrolled && mobile)) && !open;
  return (
    <div className="fixed bottom-4 right-3 z-[60] flex flex-col items-end gap-3 sm:bottom-6 sm:right-6">
      {open && CHANNELS.map((c, i) => (
        <a key={c.key} href={c.href} target="_blank" rel="noreferrer" data-testid={`floating-${c.key}-btn`}
          style={{ backgroundColor: c.color, animationDelay: `${i * 60}ms` }}
          className="fade-up flex items-center gap-2 rounded-full px-4 py-3 text-sm font-medium text-white shadow-lg">
          <c.icon size={16} /> {c.label}
        </a>
      ))}
      <button onClick={() => setOpen(!open)} data-testid="floating-contact-toggle" aria-label={demo}
        className={`relative flex h-12 items-center gap-2 rounded-full bg-gradient-to-br from-[#F3D77A] via-[#D4AF37] to-[#9A7B2C] text-xs font-bold uppercase tracking-wider text-black shadow-[0_0_25px_rgba(212,175,55,0.5)] transition-transform hover:scale-105 sm:h-14 sm:px-5 ${compact ? "w-12 justify-center px-0 sm:w-auto" : "px-4"}`}>
        {!open && !compact && <span className="absolute inset-0 animate-ping rounded-full bg-[#D4AF37]/30" />}
        {open ? <X size={18} /> : <MessageSquare size={18} />}
        <span className={`relative whitespace-nowrap ${compact ? "hidden sm:inline" : ""}`} data-testid="floating-demo-label">{demo}</span>
      </button>
    </div>
  );
};
